export default "__VITE_ASSET__CXuwZ_3z__"